var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 36,
    viewBox: "0 0 22 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36679 0.208496C5.47933 0.208496 3.66918 0.958285 2.33455 2.29292C0.999913 3.62755 0.250122 5.43771 0.250122 7.32516V28.6752C0.250122 30.5626 0.999913 32.3728 2.33455 33.7074C3.66918 35.042 5.47933 35.7918 7.36679 35.7918H14.4835C16.3709 35.7918 18.1811 35.042 19.5157 33.7074C20.8503 32.3728 21.6001 30.5626 21.6001 28.6752V25.1168H14.4835V28.6752H7.36679V7.32516H14.4835V10.8835H21.6001V7.32516C21.6001 5.43771 20.8503 3.62755 19.5157 2.29292C18.1811 0.958285 16.3709 0.208496 14.4835 0.208496H7.36679Z",
    fill: "#33697A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorc);
export default __webpack_public_path__ + "static/media/Vectorc.4de35f7118b735074a50591f57ae4245.svg";
export { ForwardRef as ReactComponent };